/**
 * Created by pandemio on 3/4/19.
 */
import React from 'react';
import { Button, Modal, ModalBody} from 'reactstrap';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheckCircle} from '@fortawesome/free-solid-svg-icons';
import {Link} from "react-router-dom";
/**
 * Modal success when setting up the profile for the first time
 */
class ModalSuccessSetupProfile extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            modal: this.props.visible,
            spacesLeft: this.props.spacesLeft
        };
        this.toggle = this.toggle.bind(this);
        this.toogleYes = this.toogleYes.bind(this);
    }

    /**
     * Hide or shows the window
     */
    toggle() {
    }

    /**
     * Toogles when yes
     */
    toogleYes(){
        this.setState({
            modal: !this.state.modal,
            answer: true
        },()=>{
            // Updates the parent (send it owns to state to update it)
            this.props.updateParent(this.state);
        });
    }

    // Render a generic modal. The body text should be sent in the text
    render() {
        return (
            <div>
                <Modal isOpen={this.state.modal} toggle={this.toggle}>
                    <ModalBody>
                        <h2 className="centered-text">
                            <FontAwesomeIcon className="green-text" icon={faCheckCircle}/> {' '}
                            <Translate id="profile-register.profile-setup-success" options={{renderInnerHtml: true}}/></h2>
                        <br/>
                        {
                            this.state.spacesLeft ? <Translate id="profile-register.add-new-student-spaces-left" /> : null
                        }
                        <hr/>
                        <div className="text-center">
                            {
                                this.state.spacesLeft ?
                                    <div>
                                    <Button color="warning" onClick={this.toogleYes}>
                                        <Translate id="profile-register.yes-add-new-student" />
                                    </Button>
                                        <h3> <Translate id="profile-register.or" /> </h3>
                                    </div>
                                    : null
                            }
                        </div>
                        <p className="text-center">
                            <Link className="btn btn-success" to="/download-first-time" color="success">
                                <Translate id="profile-register.download-the-app" />
                            </Link>
                        </p>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

export default ModalSuccessSetupProfile;